import { graphql } from "react-relay";

export const UpdateUserGroupMutation = graphql`
  mutation UpdateUserGroupMutation($input: UpdateUserGroupInput!) {
    updateUserGroup(input: $input) {
      userGroup {
        displayName
        id
        name
        roleAssignmentPrincipal
        uuid
      }
    }
  }
`;
